const TURNSTILE_TEST_KEY = '1x00000000000000000000AA';

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.getpoucher.com/v1';

export const PUBLIC_BASE_URL = import.meta.env.VITE_PUBLIC_BASE_URL || 'https://getpoucher.com';

export const TURNSTILE_SITE_KEY =
  !import.meta.env.MODE || import.meta.env.MODE === 'development'
    ? TURNSTILE_TEST_KEY
    : '0x4AAAAAACwjwNB8nbHgII2c';

export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoiZ2V0cG91Y2hlciIsImEiOiJjbDVmOXdqZDUxOTZlM21vZTJ0MmkzYW00In0.c6UKOJDQxoQYQtmDfR1sSQ';

export const MAPBOX_STYLE_STRING =
  'mapbox://styles/getpoucher/cl5u22cg0000315pdq2xgbkho?optimize=true';
